// Vendor/supplier + address-link actions for the IFS Address Book.
import { apiClient } from '../utils/apiClient';
export const vendorLinkService = {
    /** Admin: list links (optionally for one IFS account) */
    listLinks: (accountId) => apiClient.get(`/ifs-address-links${accountId ? `?accountId=${accountId}` : ''}`),
    /** Any user: my default-sender link for an IFS account */
    getMyLink: (accountId) => apiClient.get(`/ifs-address-links?mine=1&accountId=${accountId}`),
    /** Admin: link a sender address to a user (replaces prior link for that user+account) */
    createLink: (body) => apiClient.post('/ifs-address-links', body),
    /** Admin: remove a link */
    deleteLink: (id) => apiClient.delete(`/ifs-address-links?id=${id}`),
    /** Admin: create a supplier record (existing suppliers-create API) */
    createSupplier: (body) => apiClient.post('/suppliers-create', body),
    /** Admin: email a vendor an invitation to register (optionally auto-linking a supplier) */
    sendInvite: (body) => apiClient.post('/vendor-invite', body),
    /** Admin: site users for the link picker */
    listUsers: () => apiClient.get('/users-get-all'),
};
